import { useLayoutEffect, useRef } from 'react'

import { focusSilently } from '../../GretaAIChat.utils'

export function useGretaAIChatFocus({
  isMinimized,
  isOpen,
  launcherRef,
  panelRef,
}) {
  const wasVisibleRef = useRef(false)

  useLayoutEffect(() => {
    const isVisible = isOpen && !isMinimized

    if (isVisible && !wasVisibleRef.current) {
      wasVisibleRef.current = true
      panelRef.current?.focus()
    } else if (!isVisible && wasVisibleRef.current) {
      wasVisibleRef.current = false
      focusSilently(launcherRef.current)
    }
  }, [isMinimized, isOpen])
}
